
export default function(errors) {
  let return_data = {}

  let processObject = function(item, parent_name){
    for (let key  in item){
      if(key === 'non_field_errors') {
        if(item[key][0] == 'No active account found with the given credentials') item[key][0] = 'Usuário ou senha inválidos'
        alert(item[key][0])
        recInfo(key, item[key][0])
        return return_data
      }
      if(key === 'error') {
        recInfo(key, item[key])
        return return_data
      }
      let key_name = key
      if(parent_name != undefined) key_name =  parent_name + '_' + key
      checkHasChildren(key_name, item[key])
    }
  }

  let checkHasChildren = function(key, item_value){
      if(Array.isArray(item_value)){
        recInfo(key, item_value)
      } else {
        processObject(item_value, key)
      }
  }

  let recInfo = function(key, item_value){
    return_data[key] = item_value
  }

  processObject(errors)
  return return_data

}
